module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate9.8f75bf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate9.png
// module id = 768
// module chunks = 0